import { render, staticRenderFns } from "./user_proposals.vue?vue&type=template&id=28aab1b4&scoped=true&"
import script from "./user_proposals.vue?vue&type=script&lang=js&"
export * from "./user_proposals.vue?vue&type=script&lang=js&"
import style0 from "./user_proposals.vue?vue&type=style&index=0&id=28aab1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aab1b4",
  null
  
)

export default component.exports